import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import React from "react";

import MDBox from "@/components/atoms/MDBox";
import { MDButton } from "@/components/atoms/MDButton";
import MDTypography from "@/components/atoms/MDTypography";
import { PaymentTypeMessages } from "@/messages/platforms/talk2PayHome/payment-type.messages";

type Props = {
  messages: PaymentTypeMessages;
  handleOpen: () => void;
};

const NoPaymentTypeMessage = ({ messages, handleOpen }: Props) => (
  <MDBox width="82%" textAlign="center" mx="auto" my={4}>
    <MDBox mb={1}>
      <MDTypography variant="h5" color="dark" fontWeight="bold">
        {messages.noPaymentTypeMessage}
      </MDTypography>
    </MDBox>
    <MDBox mb={2}>
      <MDTypography variant="body2" color="text">
        {messages.noPaymentTypeDescription}
      </MDTypography>
    </MDBox>
    <MDButton
      onClick={handleOpen}
      variant="gradient"
      color="dark"
      endIcon={<AddCircleOutlineIcon />}
    >
      {messages.addPaymentTypeButtonLabel}
    </MDButton>
  </MDBox>
);

export default NoPaymentTypeMessage;
